// @generated by protoc-gen-es v2.9.0 with parameter "target=ts,import_extension="
// @generated from file forms/v1/success_screen.proto (package forms.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2'
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2'
import type { Message } from '@bufbuild/protobuf'

/**
 * Describes the file forms/v1/success_screen.proto.
 */
export const file_forms_v1_success_screen: GenFile =
  /*@__PURE__*/
  fileDesc(
    'Ch1mb3Jtcy92MS9zdWNjZXNzX3NjcmVlbi5wcm90bxIIZm9ybXMudjEi1wEKDVN1Y2Nlc3NBY3Rpb24SKQoIcmVkaXJlY3QYASABKAsyFS5mb3Jtcy52MS5VcmxSZWRpcmVjdEgAEjEKDnN1Y2Nlc3Nfc2NyZWVuGAIgASgLMhcuZm9ybXMudjEuU3VjY2Vzc1NjcmVlbkgAEicKB2ZvcndhcmQYAyABKAsyFC5mb3Jtcy52MS5Gb3J3YXJkVXJsSAASNQoQdmlld19saXZlX3Jlc3VsdBgEIAEoCzIZLmZvcm1zLnYxLlZpZXdMaXZlUmVzdWx0c0gAQggKBmFjdGlvbiIaCgtVcmxSZWRpcmVjdBILCgN1cmwYASABKAkiGQoKRm9yd2FyZFVybBILCgN1cmwYASABKAkiMwoNU3VjY2Vzc1NjcmVlbhINCgV0aXRsZRgBIAEoCRITCgtkZXNjcmlwdGlvbhgCIAEoCSImCg9WaWV3TGl2ZVJlc3VsdHMSEwoLZmllbGRfbmFtZXMYASADKAliBnByb3RvMw'
  )

/**
 * @generated from message forms.v1.SuccessAction
 */
export type SuccessAction = Message<'forms.v1.SuccessAction'> & {
  /**
   * @generated from oneof forms.v1.SuccessAction.action
   */
  action:
    | {
        /**
         * @generated from field: forms.v1.UrlRedirect redirect = 1;
         */
        value: UrlRedirect
        case: 'redirect'
      }
    | {
        /**
         * @generated from field: forms.v1.SuccessScreen success_screen = 2;
         */
        value: SuccessScreen
        case: 'successScreen'
      }
    | {
        /**
         * @generated from field: forms.v1.ForwardUrl forward = 3;
         */
        value: ForwardUrl
        case: 'forward'
      }
    | {
        /**
         * @generated from field: forms.v1.ViewLiveResults view_live_result = 4;
         */
        value: ViewLiveResults
        case: 'viewLiveResult'
      }
    | { case: undefined; value?: undefined }
}

/**
 * Describes the message forms.v1.SuccessAction.
 * Use `create(SuccessActionSchema)` to create a new message.
 */
export const SuccessActionSchema: GenMessage<SuccessAction> =
  /*@__PURE__*/
  messageDesc(file_forms_v1_success_screen, 0)

/**
 * @generated from message forms.v1.UrlRedirect
 */
export type UrlRedirect = Message<'forms.v1.UrlRedirect'> & {
  /**
   * @generated from field: string url = 1;
   */
  url: string
}

/**
 * Describes the message forms.v1.UrlRedirect.
 * Use `create(UrlRedirectSchema)` to create a new message.
 */
export const UrlRedirectSchema: GenMessage<UrlRedirect> =
  /*@__PURE__*/
  messageDesc(file_forms_v1_success_screen, 1)

/**
 * Bundler url to forward submission data
 *
 * @generated from message forms.v1.ForwardUrl
 */
export type ForwardUrl = Message<'forms.v1.ForwardUrl'> & {
  /**
   * @generated from field: string url = 1;
   */
  url: string
}

/**
 * Describes the message forms.v1.ForwardUrl.
 * Use `create(ForwardUrlSchema)` to create a new message.
 */
export const ForwardUrlSchema: GenMessage<ForwardUrl> =
  /*@__PURE__*/
  messageDesc(file_forms_v1_success_screen, 2)

/**
 * @generated from message forms.v1.SuccessScreen
 */
export type SuccessScreen = Message<'forms.v1.SuccessScreen'> & {
  /**
   * @generated from field: string title = 1;
   */
  title: string

  /**
   * @generated from field: string description = 2;
   */
  description: string
}

/**
 * Describes the message forms.v1.SuccessScreen.
 * Use `create(SuccessScreenSchema)` to create a new message.
 */
export const SuccessScreenSchema: GenMessage<SuccessScreen> =
  /*@__PURE__*/
  messageDesc(file_forms_v1_success_screen, 3)

/**
 * @generated from message forms.v1.ViewLiveResults
 */
export type ViewLiveResults = Message<'forms.v1.ViewLiveResults'> & {
  /**
   * @generated from field: repeated string field_names = 1;
   */
  fieldNames: string[]
}

/**
 * Describes the message forms.v1.ViewLiveResults.
 * Use `create(ViewLiveResultsSchema)` to create a new message.
 */
export const ViewLiveResultsSchema: GenMessage<ViewLiveResults> =
  /*@__PURE__*/
  messageDesc(file_forms_v1_success_screen, 4)
